import { type ActiveCapability } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfo.types';
import { type PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';
import {
  interpolateSmartPhrases,
  parseSmartPhrases,
  isPhraseSegment,
  type SmartPhraseContext,
  type SmartPhraseKey,
} from '@rsos/utils/SmartPhrases';

export const PRECONFIG_REQUEST_LOCATION = 'Request Location';

const hasMatchingSmartPhrases = (
  message: PreconfiguredResponse,
  keys: SmartPhraseKey[],
) => {
  const phrases = parseSmartPhrases(message.body);

  return phrases.some(
    phrase =>
      isPhraseSegment(phrase) &&
      keys.includes((phrase.phrase?.key ?? '') as (typeof keys)[number]),
  );
};

export const hasDisabledSmartPhrases = (
  message: PreconfiguredResponse,
  activeCapabilities: Record<string, ActiveCapability>,
): boolean =>
  parseSmartPhrases(message.body).some(
    segment =>
      isPhraseSegment(segment) &&
      segment.phrase?.capability &&
      !activeCapabilities[segment.phrase.capability],
  );

export const messageRequiresLocation = (msg: PreconfiguredResponse) => {
  // phrases that require location
  return hasMatchingSmartPhrases(msg, ['LocationRequestLink']);
};

export const messageRequiresCallerId = (msg: PreconfiguredResponse) => {
  // phrases that require caller ID
  return hasMatchingSmartPhrases(msg, [
    'LocationRequestLink',
    'VideoLink',
    'RoadsideAssistanceLink',
  ]);
};

export const getMatchingPreconfigured = (
  preconfiguredMessages: PreconfiguredResponse[],
  searchedMessage: string,
) => {
  return preconfiguredMessages.filter(preconfiguredMessage => {
    const lowerSearchedMessage = searchedMessage.toLowerCase();

    const isMatchingTitle = preconfiguredMessage.title
      .toLowerCase()
      .includes(lowerSearchedMessage);

    const isMatchingMessage = preconfiguredMessage.body
      .toLowerCase()
      .includes(lowerSearchedMessage);

    return isMatchingMessage || isMatchingTitle;
  });
};

export const handleDynamicMessage = async (
  preconfiguredMessage: PreconfiguredResponse,
  context: SmartPhraseContext,
) => {
  return {
    ...preconfiguredMessage,
    body: await interpolateSmartPhrases(preconfiguredMessage.body, context),
  };
};
